import { Routes, Route } from 'react-router-dom';
import { Spin, Result } from 'antd';
import { Layout } from './components/Layout';
import { GenericReportPage } from './components/GenericReportPage';
import { DynamicDashboard } from './components/DynamicDashboard';
import { SetupWizard } from './components/SetupWizard';
import { usePanelConfig } from './hooks/usePanelConfig';

function App() {
  const { data: config, isLoading, error } = usePanelConfig();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="Yükleniyor..." />
      </div>
    );
  }

  if (error || !config) {
    return (
      <Result
        status="error"
        title="Panel yapılandırması yüklenemedi"
        subTitle="Lütfen sayfayı yenileyin veya destek ile iletişime geçin."
      />
    );
  }

  return (
    <Layout config={config}>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <SetupWizard agentStatus={config.agentStatus} />
              <DynamicDashboard
                widgets={config.dashboard.widgets}
                reports={config.reports}
              />
            </>
          }
        />
        {config.reports.map((report) => (
          <Route
            key={report.code}
            path={`/rapor/${report.code}`}
            element={<GenericReportPage report={report} />}
          />
        ))}
      </Routes>
    </Layout>
  );
}

export default App;
